# Data health

Both engines' signals in one severity order: the drift engine's quality issues
beside the QA engine's findings, rolled up per category with exact counts.

Search covers the engine's own category names as well as their titles, so
`systemic` finds "Field lost across the matched records".

## Value mix moved between runs

Advisory, and only for fields a source profile names as categorical. It reports
how far the mix of values moved — the share of records that would have to change
value for the two runs to agree — and which values moved most.

A mix moves for legitimate reasons: solicitations open, close and get awarded
between two runs of the same source. Read it as a question, not a verdict. It
recovers nothing and gates nothing, and it stays at low severity unless the
source's owner has set the magnitude they consider notable.

## Ingestion-share proxies

The pipeline's other alert fires when an unusual share of a batch reaches
preclassification. **The export marks no such record**, so nothing here measures
that alert. What is shown instead are proxies — text fields going missing,
categorical distributions per value, document payloads failing to parse — each
as a share of this run against the reference. No threshold is applied, because
none has been established for these sources.
